import { render, staticRenderFns } from "./RecordDetail.vue?vue&type=template&id=5a6cb1b4&scoped=true"
import script from "./RecordDetail.vue?vue&type=script&lang=js"
export * from "./RecordDetail.vue?vue&type=script&lang=js"
import style0 from "./RecordDetail.vue?vue&type=style&index=0&id=5a6cb1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6cb1b4",
  null
  
)

export default component.exports